<template>
  <div class="field">
    <span v-if="label"><strong>{{ label }}: </strong></span>
    <div class="p-inputgroup">
      <Dropdown
        :modelValue="modelValue"
        @update:modelValue="$emit('update:modelValue', $event)"
        :options="gruposDisponibles"
        optionLabel="nombre"
        optionValue="id"
        :filter="true"
        :placeholder="placeholder"
        :disabled="disabled || cargando"
        :loading="cargando"
      >
        <template #option="slotProps">
          <div class="p-dropdown-car-option">
            <span>{{ slotProps.option.nombre }} </span>
          </div>
        </template>
      </Dropdown>
    </div>
  </div>
</template>

<script>
import GrupoService from '@/service/GrupoService';

export default {
  name: 'SelectGrupos',
  props: {
    modelValue: {
      type: [String, Number, Object],
      required: false
    },
    label: {
      type: String,
      default: 'GRUPO'
    },
    placeholder: {
      type: String,
      default: 'Seleccione un grupo'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    mostrarTodos: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      gruposDisponibles: [],
      cargando: false,
      grupoService: new GrupoService()
    }
  },
  mounted() {
    this.cargarGrupos();
  },
  methods: {
    async cargarGrupos() {
      this.cargando = true;
      try {
        const response = await this.grupoService.getGrupoAll();
        
        // Manejamos la respuesta para obtener el array de grupos
        let data = Array.isArray(response) 
          ? response 
          : (response.data || response.grupos || Object.values(response).find(Array.isArray) || []);
        
        if (data && data.length >= 0) {
          // Asumimos que los grupos tienen las propiedades "id" y "nombre"
          this.gruposDisponibles = data.map(grupo => {
            return {
              id: grupo.id,
              nombre: grupo.nombre || grupo.descripcion // Ajustar si es necesario
            };
          });
          
          if (this.mostrarTodos) {
            this.gruposDisponibles.unshift({ id: null, nombre: "TODOS" });
          }
          
          if (this.modelValue === undefined && this.gruposDisponibles.length > 0) {
            // Opcional: auto-seleccionar el primer elemento
            // this.$emit('update:modelValue', this.gruposDisponibles[0].id);
          }
        }
      } catch (error) {
        console.error("Error cargando grupos para el Dropdown:", error);
      } finally {
        this.cargando = false;
      }
    }
  }
}
</script>

<style scoped>
</style>
